import React from "react"

import "./HandrulesBox.css"
import HandrulesEntry from "../HandrulesEntry/HandrulesEntry"
import arrow from "../../../assets/icons/arrow.svg"
import requestHandler from "../../../utils/requestHandler"

const HandrulesBox = ({main, q, displayName, token, editMode}) => {
	let acc = 0;
	function popVote() {
		if(!token) return;
		let path = 'handrules/69/pop';
		requestHandler(path, "GET", token);
	}
	return (
		<div className="mainBox">
			{editMode ? (<div className="pop" onClick={() => {popVote()}}><img src={arrow} className="popIcon" alt="pop" /></div>): undefined}
			{main ? (<div> 
				<HandrulesEntry type={main.type} name={main.name} /> 
				</div>) : (<div className="handruleEmptyBox">
			</div>)}
			<hr></hr>
			<div className="nextHR">
				{
					q.map((entry, index) => {
						if(entry.name === displayName) {
							
							return <HandrulesEntry key={index} type={entry.type} name={entry.name} no={acc++} token={token} />
						} else {
							return <HandrulesEntry key={index} type={entry.type} name={entry.name} />
						}
					})
				}
			</div>
		</div>
	)
}

export default HandrulesBox;